import compose from "@hypnosphi/recompose/compose";
import withStyles from "@material-ui/core/styles/withStyles";
import React, { useState, forwardRef, useImperativeHandle } from "react";
import { useTranslation } from "react-i18next";

import { usePostmongerContext } from "../../contexts/PostmongerContext";

import MenuItem from "apollo-react/components/MenuItem";
import Select from "apollo-react/components/Select";

import WebinarDetails from "./Webinars/WebinarDetails";
import { isInArgumentFieldValid } from "../common/helpers";
import { fieldNames,featureFlags } from "../common/constants";

const styles = {
  section: {
    marginBottom: 32,
  },
};

export const Event = (props, ref) => {
  const { t } = useTranslation();

  const { classes } = props;

  const { inArguments, setDirty, disabled, getWebinarConnections, seedData } =
    usePostmongerContext();

  const defaultEventType = "None";
  const [eventType, setEventType] = useState(
    inArguments.get("eventType") || defaultEventType
  );
  const [isValidEvent, setIsValidEvent] = useState(true);

  if (inArguments.get("eventType") != eventType) {
    inArguments.set("eventType", eventType);
  }

  const eventTypeComponents = {
    None: () => <div></div>,
  };

  if (
    eventType === featureFlags.WEBINARS ||
    (seedData.featureFlags && seedData.featureFlags[featureFlags.WEBINARS])
  ) {
    eventTypeComponents.Webinars = WebinarDetails;
  }

  const eventTypeMenuItems = Object.keys(eventTypeComponents).map((v) => {
    return (
      <MenuItem key={v} value={v}>
        {v}
      </MenuItem>
    );
  });

  const Tagname = eventTypeComponents[eventType];

  const onEventTypeSelectChange = (e) => {
    const value = e.target.value;
    setEventType(value);
    inArguments.set("eventType", value);
    setDirty();
    if (value === featureFlags.WEBINARS) {
      getWebinarConnections();
    }
  };

  useImperativeHandle(ref, () => ({ isValid }));

  const isValid = () => {
    if (eventType === featureFlags.WEBINARS) {
      return (
        isInArgumentFieldValid(inArguments, fieldNames.webinarConnectionId) &&
        isInArgumentFieldValid(inArguments, fieldNames.webinarId) &&
        isInArgumentFieldValid(inArguments, fieldNames.occurrenceId)
      );
    }

    if(eventType === defaultEventType) {
      setIsValidEvent(false)
      return false;
  }

    return false;
  };

  return (
    <div style={{marginBottom: 32, display: "block"}}>
      <Select
        data-testid="eventType"
        name="eventType"
        label={t("EventType")}
        required
        value={eventType}
        fullWidth
        disabled={disabled}
        canDeselect={false}
        onChange={onEventTypeSelectChange}
        helperText={ 
          !isValidEvent &&<span className={classes.warning}>{t('Event.EventTypeError')}</span>
        }
        error={!isValidEvent}
      >
        {eventTypeMenuItems}
      </Select>
      <>
        <Tagname ref={ref} />
      </>
    </div>
  );
};

export default compose(withStyles(styles))(forwardRef(Event));
